import { StatsSelectors } from '@web_opxp/features';
import { useSelector } from 'react-redux';
import { IState } from '../store/state';
import { ColourblindnessStatId, DyscalculiaStatId } from './constants';

export function useColourblindnessStatValue(userId?: number) {
  const colourblindnessStat = useSelector((state: IState) =>
    StatsSelectors.getStatById(state, ColourblindnessStatId, userId)
  );
  return colourblindnessStat ? !!colourblindnessStat.valueInt : false;
}

export function useDyscalculiaStatValue(userId?: number) {
  const dyscalculiaStat = useSelector((state: IState) => StatsSelectors.getStatById(state, DyscalculiaStatId, userId));
  return dyscalculiaStat ? !!dyscalculiaStat.valueInt : false;
}
